import React from 'react';
import { Link } from 'react-router';
/*
This component is used in
components/pages/live/index.jsx
components/pages/sensorsettings/index.jsx
components/pages/stats/index.jsx
*/
const onClick = (e, x, props) => {
	if (typeof props.onClick == "function") {
		props.onClick(e, x);
	}
}
const Path = (props) => {
	return (
		<div className={"breadcrumbs"}>
			{!props.regularBc ?
				props.path.map(
					(x, idx) => (
						(idx == 0) ? (<a className="breadcrumb__root" key={idx}>{x.info.name}</a>) :
							([
								<span className="breadcrumb--divider" key={-idx}> > </span>,
								props.linkOn(x) ? (
									<Link className="breadcrumb__element--on" key={idx} to={props.link(x)} onClick={(e) => onClick(e, x, props)}>
										{x.info.name}
									</Link>
								) : (
										<Link className="breadcrumb__element--off" key={idx}>
											{x.info.name}
										</Link>
									)
							])
					)
				)
				:
				props.path.map((item, index) => {
					return (
						<React.Fragment key={index}>
							{item.shouldReload ?
								<a className="breadcrumb__element--on" onClick={() => location.reload()} >
									{item.name}
								</a>
								:
								<Link className="breadcrumb__element--on" to={item.path}>
									{item.name}
								</Link>
							}
							{index < props.path.length - 1 && <span className="breadcrumb--divider"> > </span>}
						</React.Fragment>
					)
				})
			}
		</div>
	)
}
export default Path


// WEBPACK FOOTER //
// ./src/components/common/path.jsx